import Timeslot, {
  Conflict,
  PatchConflictTypes,
  PatchTemplateTimeslotPayload,
  PostTemplateTimeSlotPayload,
} from "app/models/timeslot"

export enum Types {
  DELETE = "TIMESLOTS_DELETE",
  DELETE_SUCCESS = "TIMESLOTS_DELETE_SUCCESS",
  DELETE_FAIL = "TIMESLOTS_DELETE_FAIL",
  POST = "TIMESLOTS_POST",
  POST_SUCCESS = "TIMESLOTS_POST_SUCCESS",
  POST_FAIL = "TIMESLOTS_POST_FAIL",
  GET_BY_ID = "TIMESLOT_GET_BY_ID",
  GET_BY_ID_SUCCESS = "TIMESLOT_GET_BY_ID_SUCCESS",
  GET_BY_ID_FAIL = "TIMESLOT_GET_BY_ID_FAIL",
  PATCH = "TIMESLOTS_PATCH",
  PATCH_SUCCESS = "TIMESLOTS_PATCH_SUCCESS",
  PATCH_FAIL = "TIMESLOTS_PATCH_FAIL",
  PATCH_CONFLICTS = "CONFLICTS_PATCH",
  PATCH_CONFLICTS_SUCCESS = "CONFLICTS_PATCH_SUCCESS",
  PATCH_CONFLICTS_FAIL = "CONFLICTS_PATCH_FAIL",
}

export type Action =
  | DeleteTimeslotsByIdAction
  | DeleteTimeslotsByIdSuccessAction
  | DeleteTimeslotsByIdFailAction
  | PostTimeslotsAction
  | PostTimeslotsSuccessAction
  | PostTimeslotsFailAction
  | GetTimeslotsByIdAction
  | GetTimeslotsByIdSuccessAction
  | GetTimeslotsByIdFailAction
  | PatchTimeslotsAction
  | PatchTimeslotsSuccessAction
  | PatchTimeslotsFailAction
  | PatchConflictsAction
  | PatchConflictsSuccessAction
  | PatchConflictsFailAction

export type PostTimeslotsAction = {
  payload: { id: number; data: PostTemplateTimeSlotPayload }
  type: Types.POST
}

export type PostTimeslotsSuccessAction = {
  type: Types.POST_SUCCESS
}

export type PostTimeslotsFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export type DeleteTimeslotsByIdAction = {
  payload: { templateId: number; id: number }
  type: Types.DELETE
}

export type DeleteTimeslotsByIdSuccessAction = {
  type: Types.DELETE_SUCCESS
}

export type DeleteTimeslotsByIdFailAction = {
  payload: { errors: object }
  type: Types.DELETE_FAIL
}

export type GetTimeslotsByIdAction = {
  type: Types.GET_BY_ID
  payload: { id: number }
}

export type GetTimeslotsByIdSuccessAction = {
  type: Types.GET_BY_ID_SUCCESS
  payload: { data: Timeslot[] | undefined }
}

export type GetTimeslotsByIdFailAction = {
  type: Types.GET_BY_ID_FAIL
  payload: { errors: object }
}

export type PatchTimeslotsAction = {
  type: Types.PATCH
  payload: {
    templateId: number
    timeslot: PatchTemplateTimeslotPayload
  }
}

export type PatchTimeslotsSuccessAction = {
  type: Types.PATCH_SUCCESS
}

export type PatchTimeslotsFailAction = {
  type: Types.PATCH_FAIL
  payload: { errors: object }
}

export type PatchConflictsAction = {
  type: Types.PATCH_CONFLICTS
  payload: PatchConflictTypes
}

export type PatchConflictsSuccessAction = {
  type: Types.PATCH_CONFLICTS_SUCCESS
  payload: { data: Conflict }
}

export type PatchConflictsFailAction = {
  type: Types.PATCH_CONFLICTS_FAIL
  payload: { errors: object }
}

export function deleteTimeslotsById(templateId: number, id: number): DeleteTimeslotsByIdAction {
  return {
    payload: { templateId, id },
    type: Types.DELETE,
  }
}

export function deleteTimeslotsByIdSuccess(): DeleteTimeslotsByIdSuccessAction {
  return {
    type: Types.DELETE_SUCCESS,
  }
}

export function deleteTimeslotsByIdFail(errors: object): DeleteTimeslotsByIdFailAction {
  return {
    payload: { errors },
    type: Types.DELETE_FAIL,
  }
}

export function postTimeslots(data: PostTemplateTimeSlotPayload, id: number): PostTimeslotsAction {
  return {
    payload: { id, data },
    type: Types.POST,
  }
}

export function postTimeslotsSuccess(): PostTimeslotsSuccessAction {
  return {
    type: Types.POST_SUCCESS,
  }
}

export function postTimeslotsFail(errors: object): PostTimeslotsFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}
export function getTimeslotsById(id: number): GetTimeslotsByIdAction {
  return {
    payload: { id },
    type: Types.GET_BY_ID,
  }
}
export function getTimeslotsByIdSuccess(data: Timeslot[] | undefined): GetTimeslotsByIdSuccessAction {
  return {
    payload: { data },
    type: Types.GET_BY_ID_SUCCESS,
  }
}
export function getTimeslotsByIdFail(errors: object): GetTimeslotsByIdFailAction {
  return {
    payload: { errors },
    type: Types.GET_BY_ID_FAIL,
  }
}
export function patchTimeslots(payload: {
  templateId: number
  timeslot: PatchTemplateTimeslotPayload
}): PatchTimeslotsAction {
  return {
    payload,
    type: Types.PATCH,
  }
}
export function patchTimeslotsSuccess(): PatchTimeslotsSuccessAction {
  return {
    type: Types.PATCH_SUCCESS,
  }
}
export function patchTimeslotsFail(errors: object): PatchTimeslotsFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_FAIL,
  }
}

export function patchConflicts(payload: PatchConflictTypes): PatchConflictsAction {
  return {
    payload,
    type: Types.PATCH_CONFLICTS,
  }
}
export function patchConflictsSuccess(data: Conflict): PatchConflictsSuccessAction {
  return {
    payload: { data },
    type: Types.PATCH_CONFLICTS_SUCCESS,
  }
}
export function patchConflictsFail(errors: object): PatchConflictsFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_CONFLICTS_FAIL,
  }
}
